import { render } from "./FacilityCard.vue?vue&type=template&id=df030506&scoped=true"
import script from "./FacilityCard.vue?vue&type=script&lang=js"
export * from "./FacilityCard.vue?vue&type=script&lang=js"

import "./FacilityCard.vue?vue&type=style&index=0&id=df030506&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df030506"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon});
